import Cookies from 'js-cookie'

const bjftKeysDamin = {
    bjftkeyUser: 'BJFT_AADMIN_USER',
    bjftKeyUuid: 'BJFT_AADMIN_UUID',
    bjftKeyToken: 'BJFT_ADMIN_TOKEN'
}
let cacheData = {};

const get = function (key:any) {
    return cacheData[key]
}

const set = function (key:any, value:any) {
    if(value === null || value === undefined){
        delete cacheData[key]
        return
    }
    cacheData[key] = value
}

const getStorage = function (key:any) {
    let value = localStorage.getItem(key)
    if (value) {
        return JSON.parse(value)
    }
    return value;
}

const setStorage = function (key:any, value:any) {
    if (value === null || value === undefined) {
        localStorage.removeItem(key)
        return
    }
    value = JSON.stringify(value)
    localStorage.setItem(key, value)
}

const getCookie = function (key:any) {
    return Cookies.get(key)
}
const setCookie = function (key:any, value:any, days:any) {
    if (value !== null) {
		var inFifteenMinutes = new Date(new Date().getTime() + 8*60 * 60 * 1000); //8小时过期
		Cookies.set(key, value, { expires: inFifteenMinutes });
    } else {
        Cookies.remove(key)
    }
}
export default Object.assign(bjftKeysDamin, {
    get,
    set,
    getStorage,
    setStorage,
    getCookie,
    setCookie
})